import { sendGet } from './dataUtilities';
import env from '../env';

// TODO: add fffsocial to growth-api plan codes
const GET_COUNTRIES_BY_PLAN_CODE_ENDPOINT = '/countries/by-plan-code/fffvip';
const GET_EXCHANGE_RATE = '/exchange-rates?baseCurrency=USD&targetCurrency=GBP';

export const getCountriesByPlanCode = () => sendGet(
  env.localizationUrl + GET_COUNTRIES_BY_PLAN_CODE_ENDPOINT, {},
);

export const getExchangeRate = () => sendGet(
  env.localizationUrl + GET_EXCHANGE_RATE, {},
);

export default getCountriesByPlanCode;
